const initialState = {
  notifications: [],
};

export default function NotificationsReducers(state = initialState, action) {
  const draft = { ...state };
  switch (action.type) {
    case "add_notification": {
      draft.notifications.push(action.payload);
      return draft;
    }
    case "set_notifications":
      draft.notifications = action.payload;
      return draft;
    default:
      return state;
  }
}
